/* eslint-disable @typescript-eslint/ban-ts-ignore */
export const setPWAPrompt = () => {
  window.addEventListener("beforeinstallprompt", event => {
    event.preventDefault();
    // @ts-ignore
    window.savedPWAPrompt = event;
  });
};

export const getPWAPrompt = () => {
  // @ts-ignore
  return window.savedPWAPrompt ?? null;
};

export const removePWAPrompt = () => {
  // @ts-ignore
  window.savedPWAPrompt = undefined;
};
